const coins = {
  // صفحة نقاط المستخدم
  pageTitle: 'النقاط',
  pageSubtitle: 'رصيد نقاطك وسجل العمليات',
  balance: 'رصيد النقاط',
  balanceUnit: 'نقطة',
  rateNote: 'نقطة واحدة = {{rate}} ريال',
  signInToView: 'سجّل الدخول لعرض نقاطك',
  loadError: 'تعذّر تحميل نقاطك',

  // الشارة المختصرة
  badgeLabel: '{{count}} نقطة',

  // جدول السجل
  historyTitle: 'سجل العمليات',
  historyEmpty: 'لا توجد لديك أي عمليات نقاط بعد.',
  colDate: 'التاريخ',
  colType: 'النوع',
  colReason: 'السبب',
  colAmount: 'المبلغ',
  colBalance: 'الرصيد',
  filterAllTypes: 'كل الأنواع',
  prev: 'السابق',
  next: 'التالي',
  pageOf: 'صفحة {{page}} من {{totalPages}}',

  // تسميات أنواع العمليات (CoinTxnType)
  type: {
    PLAN_GRANT: 'منحة الباقة',
    ADMIN_CREDIT: 'إضافة من الإدارة',
    ADMIN_DEBIT: 'خصم من الإدارة',
    PURCHASE_SPEND: 'عملية شراء',
    DISCOUNT_REDEEM: 'استبدال خصم',
    REFUND_CREDIT: 'استرداد',
    ADJUSTMENT: 'تسوية',
  },

  // بطاقات الباقات
  includesCoins: 'يشمل {{count}} نقطة',
  equalsCoins: '= {{count}} نقطة',

  // لوحة الإدارة
  admin: {
    title: 'النقاط',
    subtitle: 'إدارة سعر النقطة وأرصدة المستخدمين',

    // محرّر السعر (لمشرف النظام الأعلى فقط)
    rateTitle: 'سعر صرف النقطة',
    rateSubtitle: 'حدّد قيمة النقطة الواحدة بالريال السعودي.',
    currentRate: 'السعر الحالي',
    rateValue: '{{rate}} ريال لكل نقطة',
    rateLabel: 'ريال لكل نقطة',
    rateHint: 'يجب أن يكون أكبر من صفر.',
    saveRate: 'حفظ السعر',
    rateSaved: 'تم تحديث سعر النقطة بنجاح',
    rateError: 'تعذّر تحديث سعر النقطة',
    rateInvalid: 'أدخل سعراً أكبر من صفر',
    superAdminOnly: 'يمكن لمشرفي النظام الأعلى فقط تغيير سعر النقطة.',

    // الإضافة / الخصم
    grantTitle: 'إضافة أو خصم نقاط',
    grantSubtitle: 'أضف أو اخصم من رصيد نقاط مستخدم محدّد.',
    fieldUserId: 'معرّف المستخدم',
    fieldUserIdHint: 'معرّف المستخدم المراد تعديل رصيده.',
    fieldAmount: 'المبلغ',
    fieldDirection: 'الاتجاه',
    directionCredit: 'إضافة',
    directionDebit: 'خصم',
    fieldReason: 'السبب',
    fieldReasonHint: 'يُسجَّل في سجل التدقيق وفي سجل المستخدم.',
    submit: 'تطبيق',
    submitting: 'جارٍ التطبيق...',
    grantSuccess: 'تم تحديث النقاط. الرصيد الجديد: {{balance}}',
    grantError: 'تعذّر تحديث النقاط',
    amountInvalid: 'أدخل مبلغاً أكبر من صفر',
    userIdRequired: 'أدخل معرّف المستخدم',
    reasonRequired: 'أدخل السبب',

    // لوحة سجل المستخدم
    ledgerTitle: 'رصيد المستخدم وسجله',
    ledgerBalance: 'الرصيد الحالي',
    ledgerEmpty: 'لا توجد عمليات لهذا المستخدم بعد.',
    loadUser: 'استعلام',
    loadUserError: 'تعذّر تحميل نقاط هذا المستخدم',
  },
};

export default coins;
